<header class="background-header classic-background"></header>
<section class="main-side-nav"
    [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
    <section class="container admin-dashboard-parent copy-editor-container">
        <section class="template-section-title">
            <div class="breadcrumb-container">
                <span>Admin <i class="fa fas fa-chevron-right"></i></span>
                <app-breadcrumb [pageName]="'Client Access Page'" [isTopLevel]="true"></app-breadcrumb>
            </div>
            <div class="title-container">
                <h1>Client Access Page</h1>
            </div>
        </section>
        <div class="notification-bubble-container">
            <app-notification-bubble></app-notification-bubble>
        </div>
        <!-- Search -->
        <section class="all-users-line-presentation">
            <div class="search-section">
                <div class="accounts-number">
                    <span *ngIf="professionals">{{professionals.length}} Professionals</span>
                </div>
                <div class="buttons-managment">
                    <input type="text" class="dashboard-input" placeholder="Last Name" [(ngModel)]="searchData">
                    <input type="button" class="btn btn-primary search-btn" value="Search"
                        (click)="searchByLastName(searchData)">
                </div>
            </div>
        </section>
        <!-- Table of data sought-->
        <section *ngIf="isSearching == true" class="data-sought-container">
            <app-loader *ngIf="!dataIsLoaded"></app-loader>
            <section class="all-users-data" *ngIf="usersFound">
                <div class="table-responsive admin-dashboard-table">
                    <table class="table table-hover table-borderless">
                        <thead>
                            <tr>
                                <th scope="col">First Name</th>
                                <th scope="col">Last Name</th>
                                <th scope="col">Email</th>
                                <th scope="col">Ref Code</th>
                                <th scope="col">Client Access Link</th>
                                <th scope="col">Advisor Hub</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="mappedRefCodes">
                                <ng-container *ngFor="let professional of usersFoundArray">
                                    <tr (click)="toggleSection(professional.license.refCode)">
                                        <td><span>{{professional.firstName}}</span></td>
                                        <td><span>{{professional.lastName}}</span></td>
                                        <td>{{professional.email}}</td>
                                        <td>{{professional.refCode}}</td>
                                        <td
                                            *ngIf="mappedRefCodes && mappedRefCodes[professional.license.refCode] && mappedRefCodes[professional.license.refCode].instructions.client_access_page">
                                            <a href="{{ mappedRefCodes[professional.license.refCode].instructions.client_access_page }}"
                                                target="_blank"
                                                ngbTooltip="{{ mappedRefCodes[professional.license.refCode].instructions.client_access_page }}"
                                                placement="top">Link</a>
                                        </td>

                                        <td
                                            *ngIf="mappedRefCodes && mappedRefCodes[professional.license.refCode] && mappedRefCodes[professional.license.refCode].instructions.advisor_hub">
                                            <a href="{{ mappedRefCodes[professional.license.refCode].instructions.advisor_hub }}"
                                                target="_blank"
                                                ngbTooltip="{{ mappedRefCodes[professional.license.refCode].instructions.advisor_hub }}"
                                                placement="top">Link</a>
                                        </td>
                                    </tr>
                                    <tr *ngIf="mappedRefCodes" class="body-body"
                                        [ngClass]="{'hide':selectedItemCode!=professional.license.refCode,'expanded':selectedItemCode === professional.license.refCode}">
                                        <td colspan="3">
                                            <label>
                                                <span class="label">Client Access Page Url</span>
                                                <input type="text"
                                                    [(ngModel)]="mappedRefCodes[professional.license.refCode].instructions.client_access_page">
                                            </label>
                                            <label>
                                                <span class="label">Advisor Hub</span>
                                                <input type="text"
                                                    [(ngModel)]="mappedRefCodes[professional.license.refCode].instructions.advisor_hub">
                                            </label>
                                            <input class="save-link" type="submit" value="Save"
                                                (click)="saveItem(professional.license.refCode)">
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </section>
            <div *ngIf="usersFound == false">
                <div class="not-found-message">{{message}}</div>
            </div>
            <input *ngIf="dataIsLoaded" type="button" class="btn btn-primary back-table" value="Back"
                (click)="backToTable()">
        </section>

        <!-- Table of data not sought-->
        <section class="all-users-data" *ngIf="isSearching == false">
            <div class="table-responsive admin-dashboard-table">
                <table class="table table-hover table-borderless">
                    <thead>
                        <tr>
                            <th scope="col">First Name</th>
                            <th scope="col">Last Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Ref Code</th>
                            <th scope="col">Client Access Link</th>
                            <th scope="col">Advisor Hub</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="mappedRefCodes">
                            <ng-container *ngFor="let dataUser of professionals">
                                <tr (click)="toggleSection(dataUser.license.refCode)">
                                    <td><span *ngIf="dataUser.firstName">{{ dataUser.firstName }}</span></td>
                                    <td><span *ngIf="dataUser.lastName">{{ dataUser.lastName }}</span></td>
                                    <td>{{ dataUser.email }}</td>
                                    <td>{{ dataUser.license.refCode }}</td>
                                    <td
                                        *ngIf="mappedRefCodes[dataUser.license.refCode]?.instructions?.client_access_page">
                                        <a *ngIf="mappedRefCodes[dataUser.license.refCode].instructions.client_access_page != ' '" href="{{ mappedRefCodes[dataUser.license.refCode].instructions.client_access_page }}"
                                            target="_blank"
                                            ngbTooltip="{{ mappedRefCodes[dataUser.license.refCode].instructions.client_access_page }}"
                                            placement="top">Link</a>
                                    </td>
                                    <td *ngIf="mappedRefCodes[dataUser.license.refCode]?.instructions?.advisor_hub">
                                        <a *ngIf="mappedRefCodes[dataUser.license.refCode].instructions?.advisor_hub != ' '" href="{{ mappedRefCodes[dataUser.license.refCode].instructions.advisor_hub }}"
                                            target="_blank"
                                            ngbTooltip="{{ mappedRefCodes[dataUser.license.refCode].instructions.advisor_hub }}"
                                            placement="top">Link</a>
                                    </td>
                                </tr>

                                <tr *ngIf="mappedRefCodes" class="body-body"
                                    [ngClass]="{'hide': selectedItemCode != dataUser.license.refCode, 'expanded': selectedItemCode === dataUser.license.refCode}">
                                    <td colspan="3">
                                        <label>
                                            <span class="label">Client Access Page Url</span>
                                            <input type="text"
                                                [ngModel]="editCache[dataUser.license.refCode]?.client_access_page || ''"
                                                (ngModelChange)="editCache[dataUser.license.refCode].client_access_page = $event">
                                        </label>
                                        <label>
                                            <span class="label">Advisor Hub</span>
                                            <input type="text"
                                                [ngModel]="editCache[dataUser.license.refCode]?.advisor_hub || ''"
                                                (ngModelChange)="editCache[dataUser.license.refCode].advisor_hub = $event">
                                        </label>
                                        <input class="save-link" type="submit" value="Save"
                                            (click)="saveItem(dataUser.license.refCode)">
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-container>

                    </tbody>
                </table>
            </div>
        </section>
    </section>
    <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" (pageChange)="loadPage($event)">
    </app-pagination>
</section>